import { maxBy } from 'lodash'

export const TYPES = {
  THRESHOLD: 'threshold',
  JMA: 'weather_warning',
} as const

export class Notification {
  constructor(
    public type: string,
    public id: string, // ソート可能なID 時間-アラートレベル-type-その他でユニークになるID
    public startTime: string, // 発令開始時間
    public title: string, // 通知のタイトル `${title}${level}を超えました。`
    public body: string, // 通知のメッセージ `${station.name}で${title}${level}を超えました。`
    public level: number, // アラートレベル 1:注意報、2:警報、3:特別警報
    public status: string, // api initにある閾値超過のステータスコード
    public thresholdId: string // 閾値超過ID
  ) {}
}

export default class Notifications {
  constructor(public items: Notification[]) {}

  public get last() {
    return this.items[this.items.length - 1]
  }

  public get priorOne() {
    return maxBy(this.items, 'level')
  }

  public hasItem() {
    return this.items.length > 0
  }

  public filterType(type: string) {
    return new Notifications(this.items.filter(item => item.type === type))
  }

  public thresholdList() {
    return this.filterType(TYPES.THRESHOLD)
  }

  public jmaList() {
    return this.filterType(TYPES.JMA)
  }
}
